export default __webpack_public_path__ + "static/media/feedback.dd530b4a.svg";